import { createSlice, current } from '@reduxjs/toolkit';
import {
	getReportList,
	addNewReport,
	updateReport,
	deleteReport,
	getReport,

} from '../report/thunk';

export const initialState = {
	itemReportList: [],
	itemReportDetail: null,
	isReportLoading: false,
	isReportSuccess: false,

	reportList: [],
	reportListSelect: [],

	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ReportSlice = createSlice({
	name: 'Report',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {


		builder.addCase(getReport.fulfilled, (state, action) => {
			state.isReportLoading = false;
			state.isReportSuccess = true;
			state.itemReportDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getReport.pending, state => {
			state.isReportLoading = true;
			state.isReportSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getReport.rejected, (state, action) => {
			state.isReportLoading = false;
			state.isReportSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(getReportList.fulfilled, (state, action) => {
			state.reportList = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getReportList.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getReportList.rejected, (state, action) => {
			state.error = action.error.message;
			state.isLoadingList = false;
		});
		builder.addCase(addNewReport.fulfilled, (state, action) => {
			state.isAdding = false;
			state.isAdded = true;
			state.reportList.push(action.payload);
		});
		builder.addCase(addNewReport.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewReport.rejected, state => {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});
		builder.addCase(updateReport.fulfilled, (state, action) => {
			state.isUpdating = false;
			state.isUpdated = true;			
			const index = state.reportList.findIndex(
				report => report.id === action.payload.id
			);
			state.reportList[index] = action.payload;
		});
		builder.addCase(updateReport.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateReport.rejected, state => {
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});
		builder.addCase(deleteReport.fulfilled, (state, action) => {
			state.isDeleting = false;
			state.isDeleted = true;
			state.reportList = state.reportList.filter(
				report => report.id !== action.payload.id
			);
		});
		builder.addCase(deleteReport.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});
		builder.addCase(deleteReport.rejected, state => {
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = true;
		});



	},
});

export const { setRequireCloseModal } = ReportSlice.actions;

export default ReportSlice.reducer;
